import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { Observable, of, combineLatest } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

import { AppState, Selectors } from 'store/root-reducer';
import { Customer } from 'modules/shared/models/customer.models';
import { Domain } from 'modules/shared/models/domain.models';

import { CustomerService } from 'modules/core/services/customer.service';
import { SnackbarService } from 'app/services/snackbar.service';

@Injectable()
export class CustomerInDomainGuard implements CanActivate {

  constructor(private router: Router,
              private store: Store<AppState>,
              private customerService: CustomerService,
              private snackBar: SnackbarService) {}

  canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
    return combineLatest([
        this.store.select(Selectors.domain.getCurrentDomain),
        this.store.select(Selectors.customer.getCustomer)
      ])
        .pipe(
          switchMap(([domain, currentCustomer]: [Domain, Customer]) => {
            if (currentCustomer && currentCustomer.id === activatedRouteSnapshot.params['id']) {
              return of(currentCustomer.domains.includes(domain.id));
            } else {
              return this.customerService
                .getCustomer(+activatedRouteSnapshot.params['id'])
                .pipe(map((customer: Customer) => customer.domains.includes(domain.id)));
            }
          }),
          map((customerInDomain: boolean) => {
            if (customerInDomain) {
              return true;
            } else {
              this.router.navigateByUrl('/customers');
              this.snackBar.error('The customer you were trying to access does not exist or does not belong to the current domain.');
              return false;
            }
          }),
          catchError((error: any) => {
            this.router.navigateByUrl('/customers');
            this.snackBar.error('The customer you were trying to access does not exist or does not belong to the current domain.');
            return of(false);
          })
        );
  }
}
